"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_tooltip_1 = __importDefault(require("react-tooltip"));
var style_1 = require("./style");
var PPDetailTooltip = function (props) {
    var classes = (0, style_1.useStyles)();
    var _a = (0, react_1.useState)(false), open = _a[0], setOpen = _a[1];
    var _b = (0, react_1.useState)(), expandedFields = _b[0], setExpandedFields = _b[1];
    var _c = (0, react_1.useState)(false), loading = _c[0], setLoading = _c[1];
    var handleClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    setOpen(!open);
                    if (!!open) return [3 /*break*/, 3];
                    _a = props.rowId && props.searchExpandedFields;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, props.searchExpandedFields(props.rowId, setExpandedFields)];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    _a;
                    return [3 /*break*/, 4];
                case 3:
                    setExpandedFields([]);
                    _b.label = 4;
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleLeave = function () {
        setExpandedFields([]);
        setOpen(false);
    };
    function getClassPosition(position) {
        switch (position) {
            case "Right": return classes.DetailsToolTipBodyRight;
            case "Center": return classes.DetailsToolTipBodyCenter;
            case "Left": return classes.DetailsToolTipBodyLeft;
            default: return classes.DetailsToolTipBodyCenter;
        }
    }
    function getIconPosition(position) {
        switch (position) {
            case "Right": return (!open) ? "ppi ppi-chevron-right" : "ppi ppi-chevron-left";
            case "Left": return (!open) ? "ppi ppi-chevron-left" : "ppi ppi-chevron-right";
            default: return (!open) ? "ppi ppi-chevron-right" : "ppi ppi-chevron-left";
        }
    }
    return (react_1.default.createElement(react_tooltip_1.default, { id: props.tooltipId, delayHide: props.delayHide || 250, delayShow: props.delayShow || 250, delayUpdate: props.delayUpdate || 250, backgroundColor: "transparent", className: (props.noOpacity) ? classes.DetailsToolTipNoOpacity : "", place: "left" },
        react_1.default.createElement("div", { className: classes.DetailsToolTip, onMouseLeave: function () { return handleLeave(); } },
            props.children,
            react_1.default.createElement("div", { className: props.position && getClassPosition(props.position) },
                react_1.default.createElement("div", { className: classes.DetailsToolTipBodyContent },
                    react_1.default.createElement("div", { className: (props.expandPosition && props.expandPosition == "Left") ? classes.DetailsToolTipIconPositionLeft : classes.DetailsToolTipIconPositionRight },
                        react_1.default.createElement("div", { onClick: handleClick },
                            react_1.default.createElement("i", { className: props.expandPosition && getIconPosition(props.expandPosition), style: { color: "black" } }))),
                    react_1.default.createElement("div", { className: props.expandPosition && props.expandPosition == "Left" ? classes.DetailsToolTipFieldsLeft : classes.DetailsToolTipFieldsRight },
                        props.fields &&
                            props.fields.map(function (campo, index) {
                                return (react_1.default.createElement("div", { key: index, className: classes.DetailsToolTipDivOrderFields },
                                    react_1.default.createElement("span", { className: classes.DetailsToolTipFieldsText, style: __assign({}, campo.propText) },
                                        " ",
                                        campo.text,
                                        " "),
                                    react_1.default.createElement("span", { className: classes.DetailsToolTipFieldsValue, style: __assign({}, campo.propValue) },
                                        " ",
                                        campo.value,
                                        " ")));
                            }),
                        open &&
                            react_1.default.createElement("div", { className: (props.expandPosition && props.expandPosition == "Left") ? classes.DetailsToolTipExpandLeft : classes.DetailsToolTipExpandRight },
                                react_1.default.createElement("div", { className: classes.DetailsToolTipExpand },
                                    react_1.default.createElement("div", { className: classes.DetailsToolTipBody }, !loading
                                        ? react_1.default.createElement("div", { className: (expandedFields && expandedFields.length > 0) ? classes.DetailsToolTipBodyContentExpandWithFields : classes.DetailsToolTipBodyContentExpandWithoutFields }, expandedFields && expandedFields.length > 0
                                            ? expandedFields.map(function (campo, index) {
                                                return (react_1.default.createElement("div", { key: index, className: classes.DetailsToolTipDivOrderExpandedFields },
                                                    react_1.default.createElement("span", { className: classes.DetailsToolTipExpandedFieldsValue, style: __assign({}, campo.propValue) },
                                                        " ",
                                                        campo.value,
                                                        " "),
                                                    react_1.default.createElement("span", { className: classes.DetailsToolTipExpandedFieldsText, style: __assign({}, campo.propText) },
                                                        " ",
                                                        campo.text,
                                                        " ")));
                                            })
                                            : react_1.default.createElement("span", { className: classes.DetailsToolTipSpanExtra },
                                                " ",
                                                props.expandNoResults,
                                                " "))
                                        : react_1.default.createElement("div", { className: classes.DetailsToolTipDivOrderLoading },
                                            react_1.default.createElement("span", { className: classes.DetailsToolTipSpanExtra }, " Carregando "),
                                            react_1.default.createElement(core_1.CircularProgress, { className: classes.DetailsToolTipCircular })))))))))));
};
exports.default = PPDetailTooltip;
